import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Crown, Users, BoxIcon } from 'lucide-react';
const features = [{
  icon: ShieldCheck,
  title: 'Authenticated Collectibles',
  description: 'Every item is rigorously verified by our experts and comes with a digital and physical certificate of authenticity.'
}, {
  icon: BoxIcon,
  title: 'Premium Preservation',
  description: 'Items are shipped in custom archival-grade packaging designed for both secure transport and permanent display.'
}, {
  icon: Crown,
  title: 'Exclusive Access',
  description: 'Zenith Tier members receive 48-hour early access to all limited drops and special edition releases.'
}, {
  icon: Users,
  title: 'Collector Community',
  description: 'Join a private network of serious enthusiasts to trade, discuss, and showcase your rare acquisitions.'
}];
export function ValueProps() {
  return <section className="py-24 bg-[#0A0A0A] relative overflow-hidden" data-id="element-209">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-210">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#C9A962]/5 rounded-full blur-3xl" data-id="element-211"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#6B2D3C]/5 rounded-full blur-3xl" data-id="element-212"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-213">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-214">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center group" data-id="element-215">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F5F5F0]/5 mb-6 group-hover:bg-[#C9A962]/10 transition-colors duration-300" data-id="element-216">
                <feature.icon className="w-8 h-8 text-[#C9A962]" data-id="element-217" />
              </div>
              <h3 className="text-xl font-serif text-[#F5F5F0] mb-3" data-id="element-218">
                {feature.title}
              </h3>
              <p className="text-[#F5F5F0]/60 leading-relaxed text-sm" data-id="element-219">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}